import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Tours from './pages/Tours';
import TourDetails from './pages/TourDetails';
import PlanTrip from './pages/PlanTrip';
import ContactUs from './pages/ContactUs';
import { ImageProvider } from './components/ImageContext';
import ScrollToTop from './ScrollToTop';
import ReferralTracker from './components/ReferralTrack';
import { FaWhatsapp } from 'react-icons/fa';

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <ReferralTracker />
      <ImageProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/tours" element={<Tours />} />
          <Route path="/tours/:id" element={<TourDetails />} />
          <Route path="/plan-trip" element={<PlanTrip />} />
          <Route path="/contact" element={<ContactUs />} />
        </Routes>
        
        {/* WhatsApp button visible on all pages */}
        <a
          href="https://wa.me/+250794422747" 
          className="whatsapp-icon"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaWhatsapp /> Whatsapp Us!
        </a>
      </ImageProvider>
    </Router>
  );
}

export default App;
